import { AddressData, ConnectCarData, OutputCarData } from '../@types';

export const titleForDriverCar = (
  car: OutputCarData | ConnectCarData
): string => `${car?.brand || ''} ${car?.model || ''}`;

export const parseAddress = (address: AddressData, localize = null) => {
  return address
    ? `${address?.streetName || ''} ${address?.streetNumber || ''}`
    : localize
    ? localize('address.unavailable')
    : 'Abholzone anzeigen';
};

export const getPriceMarkdown = (key, localize) =>
  !!localize(key) && localize(key) !== key ? localize(key) : null;
